export const configData = [
  {
    name: "Code Workflow",
    main_Router: "Code Workflow",
    path: "Code-Workflow",
    children: [
      {
        name: "HIM Workspace",
        path: "HIM-Workspace",
      },
      {
        name: "Coder Workspace",
        path: "Coder-Workspace"
      },
        {
          name: "Outstanding Report",
          path: "outstanding-report",
        },
        {
          name: "Error DRG Report",
          path: "error-drg-report",
        },
        {
          name: "HAC Report",
          path: "hac-report",
        },
        {
          name: "DRG Outlier Report",
          path: "drg-outlier-report",
        },
         {
          name: "Coding KPIS Report",
          path: "coding-kpis-report",
        },
           {
          name: "Coding KPIS Report",
          path: "codingkpis-coder-report",
        },
        {
          name: "Missing MVDS Report",
          path: "missing-mvds-report",
        },
            {
        name: "Coding Support",
        path: "coding-support"
      },
      {
        name: "Auditor Workspace",
        path: "Auditor-Workspace",
        children:[
          {
            name:"Code Enhance Findings",
            path:"auditor-enhance-workflow"
          },
                    {
            name: "Auditor Coding Screen",
            path: "Auditor-Coding-Screen",
          },
          {
            name: "Auditor CodeAssist Screen",
            path: "Auditor-CodeAssist-Screen",
          },
        ]
      },
      {
        name: "Create Patient Episode",
        path: "Create-Patient-Episode",
      },
    ],
  },
  {
    name: "Code Assist",
    main_Router: "Code Assist",
    children: [
      {
        name: "Episode List",
        path: "Code-Assist-Episode-list",
      },
      {
        name: "Coder",
        path: "Code-Assist",
      },
    ],
  },
      {
        "name": "Code Enhance Plus",
        "main_Router": "Code Enhance Plus",
        "children": [
            {
                "name": "Optimised Report",
                "path": "Pallas-Report"
            }
        ],
        "path": null
    },
  {
    name: "Code Accelerate",
    main_Router: "Code Accelerate",
    children: [
      {
        name: "Episode List",
        path: "Episode-list",
      },
      {
        name: "Coder",
        path: "Coder",
        children: [
          {
            name: "Upload Documents",
            path: "upload-document",
            children: [
              {
                name: "Upload",
                path: "upload-type-document",
              },
            ],
          },
        ],
      },
    ],
  },

  {
    name: "Code Enhance",
    main_Router: "Code Enhance",
    path: "Review-Enhance-Workflow", 
    children: [
      {
        name: "Discovery",
        path: "Discovery",
        children: [
          {
            name: "View Dashboard",
            path: "viewdashboard",
          },
        ],
      },
      {
        name: "Review-Enhance-Workflow",
        path: "Review-Enhance-Workflow",
        children: [
          {
            name: "Workflow Dashboard",
            path: "workflow-dashboard",
          },
        ],
      },
       {
        name: "Review Enhance Workflow",
        path: "Review-Enhance-Workflow",
        children: [
          {
            name: "Review Enhance Workflow",
            path: "Review-Enhance-Workflow",
          },
        ],
      },
    ],
  },
  {
        name: "HCP File Processor",
        path: "HCP-File-Processor",
        // children: [
        //   {
        //     name: "View Dashboard",
        //     path: "viewdashboard",
        //   },
        // ],
      },
    {
        "name": "Code Enhance Plus",
        "main_Router": "Code Enhance Plus",
        "children": [
            {
                "name": "Pallas Report",
                "path": "Pallas-Report"
            }
        ],
        "path": null
    },
  // {
  //   name: "Codie",
  //   main_Router: "Codie",
  //   children: [
  //         {
  //           name: "Chat Ai",
  //           path: "ChatAi",
  //         },
  //         {
  //           name: "Advice Search",
  //           path: "SearchCodingAdvice",
  //         },
  //   ],
  //   path: "Codie",
  // },
      {
        name: "Advice Search",
         path: "SearchCodingAdvice",
        main_Router: "Advice Search",
        children: []
    },
  {
    name: "Settings",
    main_Router: "Settings",
    children: [
      {
        name: "General",
        path: "General",
        children: [
          {
            name: "ChangePassword",
            path: "ChangePassword",
          },
          {
            name: "UpdateMail",
            path: "UpdateMail",
          },
          {
            name: "UploadDocuments",
            path: "settings-upload-document",
            children: [
              {
                name: "Upload",
                path: "upload-type-document",
              },
            ],
          },
        ],
      },
      {
        name: "Accelerate Settings",
        path: "Accelerate-settings",
      },
      {
        name: "Assist Settings",
        path: "assist-settings",
        children:[
              {
            name: "Support Rule Management",
            path: "support-rule-management",
            children:[
              {
                name: "View Rule Database",
                path: "view-rule-database",
                children:[
                  {
                    name: "Edit Active Rule",
                    path: "edit-active-rule",
                  },
                  {
                    name: "View Active Rule",
                    path: "view-active-rule",
                  },
                ]
              },
              {
                name: "Create New Rule",
                path: "create-new-rule",
              },
              {
                name: "Test Rules",
                path: "test-rule-table",
                children:[
                  {
                    name: "Submit Rule View",
                    path: "submit-rule-view",
                  },
                  {
                    name: "Test Rule Details",
                    path: "test-rule-details",
                  },
                     {
                    name: "Approved Rule Details",
                    path: "approved-rule-details",
                  },
                   {
                    name: "Published Rule Details",
                    path: "published-rule-details",
                  },
                  {
                    name: "Failed Rule Details",
                    path: "failed-rule-details",
                  },
                  {
                    name: "Failed Rule Edit",
                    path: "failed-rule-edit",
                  },
                ]
              },
              {
                name: "Archive Rules",
                path: "archived-rule",
                children:[
                  {
                name: "Archive Rule Details",
                path: "archived-rule-details",
                 },
                {
                  name: "Archive Rule Edit",
                 path: "archived-edit-rule",
                 },
                ]
              },
             

            ]
          },
          
        ]
      },
      {
        name: "Workflow Settings",
        path: "Workflow-settings",
        children: [
          {
            name: "System Configuration",
            path: "System-configuration",
          },
          {
            name: "User Management",
            path: "User-Management",
          },
        ],
      },
      {
        name: "Enhance Settings",
        path: "Enhance-settings",
      },
    ],
  },
  {
    name: "Admin",
    main_Router: "Admin",
    children: [
      {
        name: "Users",
        path: "Users",
      },
      {
        name: "Approved Users",
        path: "Approved-Users",
      },
      {
        name: "Roles",
        path: "Roles",
      },
      {
        name: "Modules",
        path: "Modules",
      },
      {
        name: "Module Permissions",
        path: "Module-Permissions",
      },
      {
        name: "Role Assignments",
        path: "Role-Assignments",
      },
      {
        name: "Organizations",
        path: "Organizations",
      },
      {
        name: "Countries",
        path: "Countries",
      },
    ],
    path: "admin",
  },
];
